/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M8.125 16.25l.881-.881-4.737-4.744h13.856v-1.25H4.269l4.737-4.744-.881-.881L1.875 10z"/>'
  }
})
